import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {EventFilters} from "../../services/ngage/events";

// Types ----

type Filters = Required<Omit<EventFilters, 'search'>>

// Custom hook ----

export default function useGetEventsBetween(
  filters: Filters,
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  const {start, end, page, perPage, siteId, typeId, params} = filters;

  return useQuery(
    ['events.between', {start: start.toISODate(), end: end.toISODate(), page, perPage, siteId, typeId}],
    ({signal}) => ngage.events.between(start, end, page, perPage, siteId, typeId, {...params, signal}),
    {enabled, keepPreviousData}
  );
}